import { render, staticRenderFns } from "./ButtonMore.vue?vue&type=template&id=1218f30a&"
import script from "./ButtonMore.vue?vue&type=script&lang=js&"
export * from "./ButtonMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports